import React from "react";
import { Row, Col } from "react-flexbox-grid";
// SCSS
import "./hero.scss";
//Assets
import HeroImage from '../../assets/hero/color_profile.png';
//Components
import Button from '../ui-components/button/button';

const hero = () => (
  <div className="hero" id="hero">
    <div className="wrapper">
      <Row>
        <Col md={12} lg={6}>
          <div className="hero-info">
            <h1 style={{color:'#1E1E1E'}}className="font24">Hi! I am Sachin.</h1>
            
            <p className="hero-subtext font30">
              Solving Business Problems With <span>Design</span> & <span>Code</span> for <span className="humanFont">People</span>.
            </p>
            
          </div>
        </Col>
        <Col md={12} lg={6}>
          <div className="hero-image">
            <img src={HeroImage} alt="hero" />
            <div className="circle"></div>
            
          </div>
        </Col>
      </Row>
    </div>
  </div>
);

export default hero;
